import {
  Avatar,
  Box,
  Button,
  Container,
  Flex,
  SimpleGrid,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import { IUserProfile } from "../../models/admin/user.model";
import AdminHelpers from "../../services/admin/admin.service";
import userService from "../../services/user.service";
import Loading from "../common/Loading";
import trainerRegistration from "../../services/trainer/trainerRegistration";

export default function EachTrainee() {
  const navigate = useNavigate();
  const { trainee_id } = useParams();
  const toast = useToast();
  const [trainee, setTrainee] = useState<IUserProfile>();
  const [traineeId, setTraineeId] = useState("");
  const [loading, setLoading] = useState(true);
  const [userNationality, setUserNationality] = useState("");

  useEffect(() => {
    if (trainee_id) setTraineeId(trainee_id);
    AdminHelpers.getEachUser(trainee_id)
      .then((response) => {
        setTrainee(response.data);
        const user_bio = response?.data?.bio;
        if (user_bio) {
          // finding the corresponding nationality name
          try {
            trainerRegistration.getNationality().then((res) => {
              const nationalities = res.data.data;
              const match = nationalities.find(
                (each: any) => each.id == parseInt(user_bio.nationality, 10)
              );
              setUserNationality(match.name);
            });
          } catch {
            console.error("No Nationality");
          }
        }
        setLoading(false);
      })
      .catch((err) => err);
  }, []);
  const approveUser = () => {
    const approvePayload = {
      approval_status: "Approved",
    };
    userService.approvalStatus(traineeId, approvePayload).then((res) => {
      toast({
        title: "Trainee Approval",
        description: "Trainee successfully approved",
        status: "success",
      });
      navigate(-1);
    });
  };
  const declineUser = () => {
    const approvePayload = {
      approval_status: "Declined",
    };
    userService.approvalStatus(traineeId, approvePayload).then((res) => {
      toast({
        title: "Decline Trainee",
        description: "Trainee successfully declined",
        status: "success",
      });
      navigate(-1);
    });
  };

  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      {loading ? (
        <Loading />
      ) : (
        <Container
          width={"80%"}
          maxWidth={"84%"}
          px={0}
          pt="60px"
          pb="60px"
          right={0}
          bg="F9F8F8"
          mx="auto"
        >
          <Box
            mb="60px"
            display="flex"
            alignItems="center"
            border="1px solid #616161"
            px="5px"
            py="7px"
            width="145px"
            borderRadius="5px"
            cursor="pointer"
          >
            <HiArrowNarrowLeft color="#616161" fontSize="20px" />
            <Text
              fontSize="14px"
              color="#616161"
              pl="5px"
              onClick={() => navigate(-1)}
              fontWeight={700}
            >
              Go Back
            </Text>
          </Box>
          <Flex
            justifyContent="space-between"
            alignContent="center"
            flexDirection={["column", "column", "row", "row"]}
            gap="1rem"
          >
            <Flex
              bg="white"
              justifyContent="center"
              flexDirection="column"
              px={["20px","20px","30px","40px"]}
              width={["100%", "95%", "30%", "25%"]}
              height="250px"
              borderRadius="16px"
              py={["20px","20px","40px","60px"]}
            >
              <Avatar mx="auto" name={trainee?.name} size="lg" />
              <Text
                color="#353535"
                textAlign="center"
                fontSize={["18px","18px","20px","21px"]}
                my="20px"
                fontWeight="700"
              >
                {trainee?.name}
              </Text>
              <Text textAlign="center">
                {" "}
                {trainee?.code !== undefined ? trainee?.code : "nil"}
              </Text>
            </Flex>
            <Box
              bg="white"
              px={["40px","40px","60px","70px"]}
              py="60px"
              width={["100%", "95%", "70%", "75%"]}
              boxShadow={"sm"}
            >
              <Text color="#353535" fontSize="21px" fontWeight="700">
                Profile Details
              </Text>

              <Box mt="25px">
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="25px">
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Email 1
                    </Text>
                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.bio?.email || "NIL"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Nationality
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {userNationality || "NIL"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      State of Origin
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.bio?.stateoforigin?.name || "NIL"}
                    </Text>
                  </Box>

                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      State of Residence
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.bio?.stateofresidence?.name || "NIL"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Date of Birth
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.bio?.dob !== undefined
                        ? trainee?.bio.dob
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Gender
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.bio?.gender !== undefined
                        ? trainee?.bio.gender
                        : "nil"}
                    </Text>
                  </Box>
                </SimpleGrid>
              </Box>

              <Box mt="25px">
                <Text
                  color="#353535"
                  fontSize="21px"
                  fontWeight="700"
                  mb="25px"
                >
                  {" "}
                  Education
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="25px">
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Institution Attended
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].institution
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Course/ Discipline
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].discipline
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Program of Study
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].program
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Class of degree
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].degree
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Year Obtained
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].year
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Certificate
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.educations[0]
                        ? trainee?.educations[0].doc
                        : "nil"}
                    </Text>
                  </Box>
                </SimpleGrid>
              </Box>

              <Box mt="25px">
                <Text
                  color="#353535"
                  fontSize="21px"
                  fontWeight="700"
                  mb="25px"
                >
                  Certifications
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="25px">
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      textTransform="capitalize"
                      fontWeight="400"
                    >
                      Certification Name{" "}
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].name
                          ? trainee.certificates[0].name
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Certification Number{" "}
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].number
                          ? trainee.certificates[0].number
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Certification Type{" "}
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].type
                          ? trainee.certificates[0].type
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Year Obtained
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].obtained
                          ? trainee.certificates[0].obtained
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Expiry Year
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].expires
                          ? trainee.certificates[0].expires
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Document
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.certificates[0]
                        ? trainee?.certificates[0].doc
                          ? trainee.certificates[0].doc
                          : "nil"
                        : "nil"}
                    </Text>
                  </Box>
                </SimpleGrid>
              </Box>

              <Box mt="25px">
                <Text
                  color="#353535"
                  fontSize="21px"
                  fontWeight="700"
                  mb="25px"
                >
                  Kit Size
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="25px">
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      T-Shirt Size
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.kit?.shirt_size !== undefined
                        ? trainee?.kit.shirt_size
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Overall Size{" "}
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.kit?.overall_size !== undefined
                        ? trainee?.kit.overall_size
                        : "nil"}
                    </Text>
                  </Box>
                  <Box minW="200px">
                    <Text
                      color="#959595"
                      mb="10px"
                      fontSize="15px"
                      fontWeight="400"
                    >
                      Shoe Size
                    </Text>

                    <Text
                      color="#616161"
                      fontSize="17px"
                      textTransform="capitalize"
                      fontWeight="500"
                      textAlign="left"
                    >
                      {trainee?.kit?.shoe_size !== undefined
                        ? trainee?.kit.shoe_size
                        : "nil"}
                    </Text>
                  </Box>
                </SimpleGrid>
              </Box>

              {trainee?.approval_status == "New" && (
                <Flex justifyContent="flex-end" alignContent="center" mb="30px">
                  <Button
                    py="13px"
                    px="30px"
                    onClick={() => {
                      declineUser();
                    }}
                    mt="30px"
                    type="submit"
                    fontSize={16}
                    bg="#F5F5F5"
                    color="#353535"
                    size="md"
                  >
                    Decline
                  </Button>
                  <Button
                    py="13px"
                    px="30px"
                    onClick={() => {
                      approveUser();
                    }}
                    mt="30px"
                    ml="20px"
                    type="submit"
                    fontSize={16}
                    colorScheme="red"
                    size="md"
                  >
                    Approve
                  </Button>
                </Flex>
              )}
            </Box>
          </Flex>
        </Container>
      )}
    </Box>
  );
}
